import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/hooks/useApi';
import type {
  LeaderboardResponse,
  MyWeeklyMinimum,
  ChallengeWithStandings,
  StreaksResponse,
} from '@/api/types';

const KEYS = {
  leaderboard: ['gamification', 'leaderboard'] as const,
  challenges: ['gamification', 'challenges'] as const,
  streaks: ['gamification', 'streaks'] as const,
};

export function useLeaderboard() {
  const api = useApi();
  return useQuery({
    queryKey: KEYS.leaderboard,
    queryFn: () => api.get<LeaderboardResponse>('/portal/gamification/leaderboard'),
    staleTime: 60_000,
  });
}

export function useChallenges() {
  const api = useApi();
  return useQuery({
    queryKey: KEYS.challenges,
    queryFn: () => api.get<ChallengeWithStandings[]>('/portal/gamification/challenges'),
    staleTime: 60_000,
  });
}

export function useStreaks() {
  const api = useApi();
  return useQuery({
    queryKey: KEYS.streaks,
    queryFn: () => api.get<StreaksResponse>('/portal/gamification/streaks'),
    staleTime: 60_000,
  });
}

/** The caller's messages this week against their weekly minimum, if any. */
export function useWeeklyMinimum() {
  const api = useApi();
  return useQuery({
    queryKey: ['portal', 'weekly-minimum'] as const,
    queryFn: () => api.get<MyWeeklyMinimum>('/portal/contacts/weekly-minimum'),
    staleTime: 30_000,
  });
}
